import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

// make lat and lng mandatory again
export const GET_DROP_OFF_POINTS: DocumentNode = gql`
  query GetDropOffPoints(
    $city: String!
    $country: String!
    $couriers: [String]!
    $limit: Int!
    $zip: String!
    $lat: Float
    $lng: Float
  ) {
    getDropOffPoints(
      city: $city
      country: $country
      couriers: $couriers
      limit: $limit
      zip: $zip
      lat: $lat
      lng: $lng
    ) {
      courier
      dayOfWeek {
        day
        hours
      }
      pointId
      pointName
      street
      zip
      city
      latitude
      longitude
      distanceFromOrigin {
        value
      }
      imageURL
    }
  }
`;
